import {
  ImproveSortColumnEnum,
  SortOrderEnum,
} from '@ulysses-inc/harami_api_client'
import { localStorageKeys } from 'src/constants/localStorageKeys'
import { LocalStorageService } from 'src/libraries/localStorage'

export type ImprovesSortOrder = {
  sortColumn: ImproveSortColumnEnum
  sortOrder: SortOrderEnum
}

/**
 * 初回表示・並び替えクリア時の既定値。
 * API 側の sortColumn 未指定時の挙動 (実施日 DESC) と一致させ、UI 上でも明示する。
 */
export const DEFAULT_IMPROVES_SORT_ORDER: ImprovesSortOrder = {
  sortColumn: ImproveSortColumnEnum.ReportDate,
  sortOrder: SortOrderEnum.Desc,
}

const VALID_SORT_COLUMNS = Object.values(ImproveSortColumnEnum) as string[]
const VALID_SORT_ORDERS = Object.values(SortOrderEnum) as string[]

const isValidSortOrder = (value: unknown): value is ImprovesSortOrder => {
  if (value === null || typeof value !== 'object') return false
  const candidate = value as Partial<ImprovesSortOrder>
  return (
    typeof candidate.sortColumn === 'string' &&
    VALID_SORT_COLUMNS.includes(candidate.sortColumn) &&
    typeof candidate.sortOrder === 'string' &&
    VALID_SORT_ORDERS.includes(candidate.sortOrder)
  )
}

const localStorageService = new LocalStorageService<ImprovesSortOrder>()

/**
 * カイゼン一覧の並び替えの条件をローカルストレージで管理する
 *
 * 絞り込みに影響が出ないように listFilter とは key を分ける
 */
export const improvesSortOrderStorage = {
  get: (): ImprovesSortOrder | null => {
    const raw = localStorageService.getItem(localStorageKeys.sortOrderImproves)
    if (!isValidSortOrder(raw)) {
      // 破損 JSON や旧仕様の値が残っている場合はクリーンアップして null を返す
      if (raw !== null) {
        localStorage.removeItem(localStorageKeys.sortOrderImproves)
      }
      return null
    }
    return raw
  },
  set: (updatedSortOrder: ImprovesSortOrder) => {
    localStorageService.setItem(
      localStorageKeys.sortOrderImproves,
      updatedSortOrder,
    )
  },
  remove: () => {
    localStorage.removeItem(localStorageKeys.sortOrderImproves)
  },
}
